import React from "react"
import Footer from "../components/Footer"
import Header from "../components/Header"
import PrimaryResourcesCategoryView from "./PrimaryResourcesCategoryView"
import PDFLogo from "../images/pdf.svg"
import ZipLogo from "../images/zip.svg"
import Grade1TB from "../images/grade-1-tb.jpg"

class Primary1Resources extends React.Component {
  state = {
    view: {
      title: "Primary 1 Resources",
      parentURL: "/resources",
      parentName: "resources",
      categories: [
        {
          name: "Teacher's Book",
          file: Grade1TB,
          filePath:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/resources-nov-2022/G1-Primary-1-TB_WM_2022.pdf",
        },
        {
          name: "Flashcards",
          fileType: PDFLogo,
          filePath:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/resources-primary-1-jan-2021/",
          files: [
            {
              name: "Grade 1 Flashcards",
              file: "LBY0031_G1_Flashcards_2020_FINAL.pdf",
            },
          ],
        },
        {
          name: "Posters",
          fileType: PDFLogo,
          filePath:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/resources-primary-1-jan-2021/",
          files: [
            {
              name: "Grade 1 Alphabet Poster",
              file: "LBY0031_G1_Alphabet_Poster_2020_FINAL.pdf",
            },
            {
              name: "Grade 1 Colours and Numerals Poster",
              file: "LBY0031_G1_Colours_and_numerals_Poster_2020_FINAL.pdf",
            },
            {
              name: "Grade 1 Family Poster",
              file: "LBY0031_G1_Family_Poster_2020_FINAL.pdf",
            },
            {
              name: "Grade 1 House Poster",
              file: "LBY0031_G1_House_Poster_2020_FINAL.pdf",
            },
          ],
        },
        {
          name: "Audio",
          fileType: ZipLogo,
          filePath:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/audio-april-2022/",
          files: [{ name: "Grade 1 Audio", file: "Primary-1-audio.zip" }],
        },
      ],
    },
  }

  render() {
    return (
      <div>
        <Header />

        <PrimaryResourcesCategoryView data={this.state.view} />

        <Footer />
      </div>
    )
  }
}

export default Primary1Resources



// WEBPACK FOOTER //
// ./src/components/ResourcesPrimary1.js